import moment from "moment";
import { RfqStatusCode } from "../../models/models";

export enum VisibilityPresetCode {
  all = 0,
  public = 1,
  customList = 2
}

export const visibilityPresets = [
  {
    label: "All",
    value: VisibilityPresetCode.all,
    disabled: false,
    queryParams: {visibilityCode: VisibilityPresetCode.all}
  },
  {
    label: "Public",
    value: VisibilityPresetCode.public,
    disabled: false,
    queryParams: {visibilityCode: VisibilityPresetCode.public}
  },
  {
    label: "Custom list",
    value: VisibilityPresetCode.customList,
    disabled: true,
    queryParams: {visibilityCode: VisibilityPresetCode.customList}
  }
];

export enum FulfillmentPresetCode {
  all = 0,
  lastCallSoon = 1,
  fulfilled = 2,
  archived = 4
}

export const fulfillmentPresets = [
  {
    label: "All RFQs",
    value: FulfillmentPresetCode.all,
    queryParams: { statusCodes: [], lastCallTo: undefined }
  },
  {
    label: "Last call soon",
    value: FulfillmentPresetCode.lastCallSoon,
    queryParams: { statusCodes: [RfqStatusCode.open], lastCallTo: moment().add(1, "days").toISOString() }
  },
  {
    label: "Fulfilled",
    value: FulfillmentPresetCode.fulfilled,
    queryParams: { statusCodes: [RfqStatusCode.confirmed], lastCallTo: undefined }
  },
  {
    label: "Archived",
    value: FulfillmentPresetCode.archived,
    queryParams: { statusCodes: [RfqStatusCode.closed, RfqStatusCode.archived], lastCallTo: undefined }
  }
];

export const matchStatusCodes = (statusCodes: Array<RfqStatusCode>, queryStatusCodes: Array<RfqStatusCode>) => {
  return statusCodes.length === queryStatusCodes.length
    ? statusCodes.every((statusCode) => queryStatusCodes.includes(statusCode))
    : false;
}